export class Controller {

    /** @ngInject */
    constructor(
        $state,
        AddNewSharedPasswordModal,
        ImportSharedPasswordsModal,
        AddNewSharedAuthenticatorModal,
        ImportSharedAuthenticatorsModal,
        ShareAnAdditionalEmailAccount
    ) {
        this.$state = $state;
        this.AddNewSharedPasswordModal = AddNewSharedPasswordModal;
        this.ImportSharedPasswordsModal = ImportSharedPasswordsModal;
        this.ImportSharedAuthenticatorsModal = ImportSharedAuthenticatorsModal;
        this.AddNewSharedAuthenticatorModal = AddNewSharedAuthenticatorModal;
        this.ShareAnAdditionalEmailAccount = ShareAnAdditionalEmailAccount;
    }

    $onInit() {
    }

    showAuthenticatorAddModal() {
        this.publicServicesWithSsoAnd2FA$.get()
            .then(items => this.AddNewSharedAuthenticatorModal(items))
            .then(() => this.$state.reload(this.$state.current))
    }

    showAuthenticatorImportModal() {
        this.ImportSharedAuthenticatorsModal().then(() => this.$state.reload(this.$state.current));
    }

    showPasswordManagerAddModal() {
        this.publicServicesWithSso$.get()
            .then(items => this.AddNewSharedPasswordModal(items))
            .then(() => this.$state.reload(this.$state.current))
    }

    showPasswordManagerImportModal() {
        this.ImportSharedPasswordsModal().then(() => this.$state.reload(this.$state.current));
    }
    showShareAnAdditionalEmailAccountModal() {
        this.ShareAnAdditionalEmailAccount();
    }

    stateCheckSharedPasswords() {
        return this.$state.is('company.sharing-center.shared-passwords');
    }
    stateCheckSharedAuthenticator() {
        return this.$state.is('company.sharing-center.shared-authenticators');
    }
    stateCheckCompanyAccount() {
        return this.$state.is('company.sharing-center.shared-accounts');
    }
}


// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/sharing-center.controller.js